import { analytics } from './config';
import { logEvent } from 'firebase/analytics';

// Event names
export const EVENTS = {
  // Authentication events
  SIGN_UP: 'sign_up',
  LOGIN: 'login',
  LOGOUT: 'logout',
  
  // Item management events
  ADD_ITEM: 'add_item',
  UPDATE_ITEM: 'update_item',
  DELETE_ITEM: 'delete_item',
  SCAN_BARCODE: 'scan_barcode',
  
  // Waste logging events
  LOG_WASTE: 'log_waste',
  EXPORT_DATA: 'export_data',
  
  // Community events
  CREATE_POST: 'create_post',
  ADD_COMMENT: 'add_comment',
  EARN_POINTS: 'earn_points',
  EARN_BADGE: 'earn_badge',
  
  // Error events
  ERROR: 'error',
};

// Analytics service
export const AnalyticsService = {
  /**
   * Log an event with optional parameters
   * @param {string} eventName - Name of the event
   * @param {Object} [params] - Optional parameters for the event
   */
  logEvent: (eventName, params = {}) => {
    try {
      logEvent(analytics, eventName, params);
    } catch (error) {
      console.error('Analytics error:', error);
    }
  },

  /**
   * Log an error event
   * @param {Error} error - The error object
   * @param {string} context - Where the error occurred
   */
  logError: (error, context) => {
    try {
      logEvent(analytics, EVENTS.ERROR, {
        error_message: error.message,
        error_stack: error.stack,
        context,
        timestamp: new Date().toISOString(),
      });
    } catch (analyticsError) {
      console.error('Error logging to analytics:', analyticsError);
    }
  },

  /**
   * Log user action with timing
   * @param {string} action - The action performed
   * @param {number} duration - Time taken in milliseconds
   */
  logTiming: (action, duration) => {
    try {
      logEvent(analytics, 'timing', {
        action,
        duration,
        timestamp: new Date().toISOString(),
      });
    } catch (error) {
      console.error('Error logging timing:', error);
    }
  },
};

export default AnalyticsService; 